import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button, Card, Form, Input, Typography } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNotificationContext } from '../../services/NotificationContext';
import { signon } from '../../api/auth/auth';
import { IFetcher } from '../../libs/fetcher';
import { useAuth } from '../../services/AuthContext';
import useLoading from '../../hooks/useLoading';
import ImageLogo from '../../pictures/logo-its-2.png';
import LoginStyles from './Styles';

const { Title, Text } = Typography;

const ModalLogin = () => {
    const { login, isAuthenticated } = useAuth();
    const { styles } = LoginStyles();
    const { show } = useNotificationContext();
    const hookLoading = useLoading({ defaultLoading: false });
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || "/";

    // Efecto para poner y quitar la imagen de fondo de pantalla del login
    useEffect(() => {
        document.body.classList.add("setImage");    // Al iniciar el componente
        return () => {
            document.body.classList.remove("setImage"); // Añ salir del componente
        }
    }, []);
    // Redireccionar a la página solicitada
    useEffect(() => {
        if (isAuthenticated) navigate(from, { replace: true });
    }, [isAuthenticated]);

    const onFinish = (values: { username: string; password: string }) => {
        hookLoading.start();
        const { username, password } = values;
        const data = { username, password, app: 'I' }
        console.log('Valores del formulario:', values);
        signon(data)
            .then((response) => {
                const { fetch } = response;
                handleResponse(fetch);
            })
            .catch(() => {
                show('error', '¡Ha ocurrido evento inesperado!', 'Inténtelo más tarde');
            })
            .finally(() => {
                hookLoading.end();
            });
    };

    const handleResponse = (fetch: IFetcher['fetch']) => {
        if (typeof fetch === 'string') {
            // Manejar si fetch es cadena
        } else if (fetch instanceof Object) {
            if ('status' in fetch) {
                if (fetch.status === 200) {
                    const responseData = 'data' in fetch ? fetch.data : null;
                    if (responseData) {
                        show('success', '¡Sesión iniciada!', 'Inicio de sesión satisfactorio. Bienvenido a Victum ITS.');
                        login(responseData);
                    } else {
                        show('warning', '¡Ha ocurrido un error!', 'No se pudo obtener una respuesta, inténtelo más tarde.');
                    }
                } else if (fetch.status === 401) {
                    const responseData = 'data' in fetch ? fetch.data : null;
                    show('warning', responseData.error, responseData.message);
                } else if (fetch.status === 0) {
                    show('error', 'Error de comunicación', 'Ha ocurrdio un error al tratar de realizar la comunicación con los servidores. Revise su conexión a internet');
                }
            }
        }
    };
    return (
        <Modal
            show
            centered
            animation
            size='sm'
        >
            <div className="login-container">
                <Card className="login-box">
                    <div className='login' id='header' style={styles.header}>
                        <center>
                            <img src={ImageLogo} alt="Login illustration" style={styles.logo} />
                        </center>
                        <Title style={styles.title}>Acceder</Title>
                        <Text style={styles.text}>
                            Bienvenido a Victum ITS
                        </Text>
                    </div>
                    <Form
                        name="login-form"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            rules={[
                                { required: true, message: 'Por favor ingresa tu nombre de usuario' },
                                { type: 'string', message: 'Ingresa un nombre de usuario válido' },
                            ]}
                        >
                            <Input
                                prefix={<UserOutlined />}
                                placeholder="Nombre de usuario"
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Contraseña"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                loading={hookLoading.isLoading}
                            >
                                Ingresar
                            </Button>
                        </Form.Item>
                    </Form>
                    <div className="login-footer">
                        <a href="/forgot-password">¿Olvidaste tu contraseña?</a>
                        {/* <a href="/signup">Regístrate</a> */}
                    </div>
                </Card>
            </div>
        </Modal>
    )
}

export default ModalLogin